import React from 'react'
import {
  BrowserRouter as Router,
  Routes, Route, useLocation, useRoutes, useParams
} from "react-router-dom";
import Qrscan1 from './Qrscan1';
import Qrscancamera from './Qrscancamera';
import Successpage from './Successpage';
import Topay from './Topay';

const Mainroute = () => {
  return (
    <div className="mobile-container">


      <Routes>
        <Route path='/*' element={<Qrscan1 />} />
      </Routes>
    </div>
  )
}

export default Mainroute